<!-- prettier-ignore -->
<template>
    <v-stepper-content :step="step">
        <div>
            <div class="text-center">
                <v-icon x-large center>mdi-check</v-icon>
            </div>
            <v-row justify="center">
                <v-col cols="12" sm="10" md="8" lg="6" class="text-center">
                    <template v-if="$store.get('enrollment/selected@id') == 13">
                        Terimakasih telah mendaftar :)<br>
                        Admin akan aktifkan pendaftaranmu pada <strong>20 Mei 2023 17:00 WIB</strong><br>
                        untuk perbarui status klik <strong>Muat Ulang</strong> di bawah<br>
                        <br>Try out bisa dikerjakan mulai <strong>20 Mei 2023 pukul 17:00 WIB</strong><br>

                        Silahkan Join salah satu grup Whatsapp melalui link di bawah untuk mendapatkan pengumuman selanjutnya<br>
                        <a href="https://chat.whatsapp.com/CsRm2u4HHPN2iIlJ4JwEfG">Grup 1</a>

                        <br>Apabila ada kendala, hubungi admin di:<br />
                        <admin-contact></admin-contact>
                    </template>

                    <template v-else-if="$store.get('enrollment/selected@id') == 11">
                        Terimakasih telah mendaftar :)<br>
                        Silakan menghubungi admin untuk aktivasi akun gratis <a href="https://wa.me/+6281287180586" target="_blank">+6281287180586</a>, pengerjaan dapat dilakukan setelah aktivasi

                        <br>Apabila ada kendala, hubungi admin di:<br />
                        <admin-contact></admin-contact>
                    </template>

                    <template v-else-if="$store.get('enrollment/selected@id') == 8">
                        Terimakasih telah mendaftar :)<br>
                        Silakan menghubungi admin untuk aktivasi akun gratis <a href="https://wa.me/+6281287180586" target="_blank">+6281287180586</a>, pengerjaan dapat dilakukan setelah aktivasi

                        <br>Apabila ada kendala, hubungi admin di:<br />
                        <admin-contact></admin-contact>
                    </template>

                    <template v-else-if="$store.get('enrollment/selected@id') == 6">
                        Terimakasih telah mendaftar :)<br>
                        Silakan menghubungi admin untuk aktivasi akun gratis <a href="https://wa.me/+6281287180586" target="_blank">+6281287180586</a>, pengerjaan dapat dilakukan setelah aktivasi

                        <br>Apabila ada kendala, hubungi admin di:<br />
                        <admin-contact></admin-contact>
                    </template>

                    <template v-else-if="$store.get('enrollment/selected@id') == 7">
                        Terimakasih telah mendaftar :)<br>
                        Silakan menghubungi admin untuk aktivasi akun gratis <a href="https://wa.me/+6281287180586" target="_blank">+6281287180586</a>, pengerjaan dapat dilakukan setelah aktivasi

                        <br>Apabila ada kendala, hubungi admin di:<br />
                        <admin-contact></admin-contact>
                    </template>

                    <template v-else-if="$store.get('enrollment/selected@id') == 5">
                        Terimakasih telah mendaftar :)<br>
                        Admin akan aktifkan pendaftaranmu pada <strong>1 April 2023 17:00 WIB</strong><br>
                        untuk perbarui status klik <strong>Muat Ulang</strong> di bawah<br>
                        <br>Try out bisa dikerjakan mulai <strong>1 April 2023 pukul 17:00 WIB</strong><br>

                        Silahkan Join salah satu grup Whatsapp melalui link di bawah untuk mendapatkan pengumuman selanjutnya<br>
                        <a href="https://chat.whatsapp.com/CsRm2u4HHPN2iIlJ4JwEfG">Grup 1</a>

                        <br>Apabila ada kendala, hubungi admin di:<br />
                        <admin-contact></admin-contact>
                    </template>

                    <template v-else>
                        Kamu sudah upload bukti pendaftaran.<br />
                        Admin akan segera mengkonfirmasi bukti yang kamu kirim. <br />
                        Apabila pendaftaranmu belum dikonfirmasi, kamu bisa menghubungi admin di
                        <admin-contact></admin-contact>
                        Muat ulang halaman untuk mendapatkan status terbaru.
                    </template>
                </v-col>
            </v-row>

            <div class="text-center">
                <v-btn @click="reload" text>Muat ulang</v-btn>
            </div>
        </div>
    </v-stepper-content>
</template>

<script>
import AdminContact from './AdminContact'

export default {
    props: {
        step: {
            type: String,
        },
    },

    components: {
        AdminContact,
    },

    methods: {
        reload() {
            window.location.reload()
        },
    },
}
</script>
